import React, {useState} from 'react';
import {StyleSheet} from 'react-native';
import RNDropDownPicker from 'react-native-dropdown-picker';

import theme from '../../style/theme';

function DropDownPicker({items, onSelectItem, placeholder}) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);

  return (
    <RNDropDownPicker
      listMode="SCROLLVIEW"
      open={open}
      value={value}
      items={items}
      setOpen={setOpen}
      setValue={setValue}
      onSelectItem={onSelectItem}
      disableLocalSearch={true}
      placeholder={placeholder}
      itemSeparator={true}
      showArrowIcon={false}
      disableBorderRadius={true}
      placeholderStyle={styles.placeholderStyle}
      style={[styles.pickerStyle, {display: open ? 'none' : 'flex'}]}
      containerStyle={styles.containerStyle}
      labelStyle={styles.labelStyle}
      dropDownContainerStyle={styles.dropDownContainerStyle}
      listItemContainerStyle={styles.listItemContainerStyle}
      listItemLabelStyle={styles.listItemLabelStyle}
      itemSeparatorStyle={styles.itemSeparatorStyle}
      scrollViewProps={{keyboardShouldPersistTaps: 'always'}}
    />
  );
}

const styles = StyleSheet.create({
  main: {
    flex: 1,
    backgroundColor: 'white',
    paddingVertical: 24,
    paddingHorizontal: 16,
    alignItems: 'stretch',
    justifyContent: 'space-between',
  },
  textInput: {
    fontSize: 20,
    fontWeight: '400',
    fontFamily: undefined,
    color: theme.colour.text.form.textInput.primary,
  },
  placeholderStyle: {
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
    fontSize: 20,
    fontWeight: '400',
    fontFamily: undefined,
    color: '#BBB',
  },
  pickerStyle: {
    minHeight: 64,
    borderColor: 'grey',
    borderWidth: 0.5,
    borderRadius: 4,
  },
  containerStyle: {
    borderRadius: 4,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
  },
  labelStyle: {
    fontSize: 20,
    fontWeight: '400',
    fontFamily: undefined,
    color: theme.colour.text.form.textInput.primary,
  },
  searchContainerStyle: {
    padding: 0,
    minHeight: 32,
    borderBottomWidth: 0,
  },
  searchTextInputStyle: {
    minHeight: 32,
    maxHeight: 32,
    fontSize: 18,
    fontWeight: '400',
    fontFamily: undefined,
    color: theme.colour.text.form.textInput.primary,
    borderRadius: 4,
    borderWidth: 0.5,
    borderColor: 'grey',
  },
  searchTextInputStyleOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderWidth: 0,
    borderBottomWidth: 1,
  },
  dropDownContainerStyle: {
    borderWidth: 0.5,
    paddingLeft: 0,
    paddingRight: 0,
    borderColor: 'grey',
    borderTopRightRadius: 4,
    borderTopEndRadius: 4,
    borderTopStartRadius: 4,
    position: 'relative',
    zIndex: 500,
  },
  listItemContainerStyle: {},
  itemSeparatorStyle: {
    borderBottomWidth: 0.5,
    borderColor: 'grey',
  },
  listItemLabelStyle: {
    color: theme.colour.text.form.textInput.primary,
    fontFamily: undefined,
  },
  manualInput: {
    fontSize: 20,
    fontWeight: '400',
    fontFamily: undefined,
    paddingLeft: 12,
    height: 32,
    borderColor: 'grey',
    borderWidth: 0.5,
    borderRadius: 4,
    color: theme.colour.text.form.textInput.primary,
  },
  validationError: {
    fontSize: 12,
    fontWeight: '400',
    color: 'red',
    marginTop: 4,
    marginBottom: 8,
  },
});

export default DropDownPicker;
